module.exports = __webpack_public_path__ + "static/media/greece_flag.de9a6eb5.png";